import {createAction} from 'web-app/util/redux/famly-app-helpers';

import type * as Types from './types';

const domain = 'NOTIFICATION_HOURS_SETTINGS';

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(
    `${domain}/FETCH`,
    () => ({}),
    (payload: {formData: Types.FormData; show: boolean}) => payload,
);

export const {
    action: fetchTimezones,
    success: fetchTimezonesSuccess,
    failed: fetchTimezonesFailed,
} = createAction(
    `${domain}/FETCH_TIMEZONES`,
    () => ({}),
    (timezones: Types.Option[]) => ({timezones}),
);

export const {
    action: update,
    success: updateSuccess,
    failed: updateFailed,
    aborted: updateAborted,
} = createAction(
    `${domain}/UPDATE`,
    (formData: Types.FormData & {timezone: string}, isEmployee: boolean) => ({formData, isEmployee}),
    (formData: Types.FormData) => ({formData}),
);
